import styled from 'styled-components';
import { Ellipsis } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

const snowflakeHeight = 50;

export const CompetitorWrapper = styled.section`
  position: relative;
  text-align: left;
  cursor: pointer;
  margin-left: -${({ theme }) => theme.x2spacePx}px;
  margin-right: ${({ theme }) => theme.x2spacePx}px;
`;

export const CompetitorDetails = styled.div`
  padding-right: ${({ theme }) => theme.x4spacePx}px;
  padding-left: ${({ theme }) => snowflakeHeight + theme.x4spacePx}px;
  padding-top: 26px;
  p,
  h4 {
    margin-top: 0;
    margin-bottom: 0;
    ${Ellipsis};
    line-height: 1;
  }
  p {
    ${({ theme }) => theme.typography.small}
    margin-bottom: ${({ theme }) => theme.x1spacePx / 2}px;
  }
  h4 {
    ${({ theme }) => theme.typography.xSmall}
    text-transform: uppercase;
    opacity: 0.7;
  }
`;

export const CompetitorSnowflake = styled.div`
  width: ${snowflakeHeight}px;
  position: absolute;
  left: ${({ theme }) => theme.x2spacePx}px;
  top: 19px;
  ${media.mdDown`
		top: ${({ theme }) => theme.x2spacePx}px;
	`};
`;
